import ApiClient from '../../../helpers/apiClient';

export const FETCH_PLATFORM_DAILY_STATISTICS_REQUEST = 'FETCH_PLATFORM_DAILY_STATISTICS_REQUEST';
export const FETCH_PLATFORM_DAILY_STATISTICS_SUCCESS = 'FETCH_PLATFORM_DAILY_STATISTICS_SUCCESS';
export const FETCH_PLATFORM_DAILY_STATISTICS_ERROR = 'FETCH_PLATFORM_DAILY_STATISTICS_ERROR';

export const fetchPlatformDailyStatistics = (startDate, endDate, platformName) => dispatch => {
  const params = { startDate, endDate };
  if (platformName) {
    params.platformName = platformName;
  }

  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_PLATFORM_DAILY_STATISTICS_REQUEST,
        FETCH_PLATFORM_DAILY_STATISTICS_SUCCESS,
        FETCH_PLATFORM_DAILY_STATISTICS_ERROR,
      ],
      callAPI: () =>
        ApiClient.get('network/DataPlanUsageCheckTracking/GetPlatformDailyStatistics', {
          params,
        }),
      payload: { startDate, endDate, platformName },
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_PLATFORM_DAILY_STATISTICS_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_PLATFORM_DAILY_STATISTICS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response?.data?.data || [],
        },
        response,
        successMessage,
      };

    case FETCH_PLATFORM_DAILY_STATISTICS_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
